import React from 'react'
import PropTypes from 'prop-types'

import { Link } from 'react-router'
import { Table } from 'semantic-ui-react'

import GroupsTableHeader from 'Components/GroupsTable/GroupsTableHeader'

import * as styles from './styles'

const GroupsTable = props => {
  const { groups, handleSort, sortBy, sortOrder } = props

  const mappedGroups = groups.map(group => {
    return (
      <Table.Row key={group.id}>
        <Table.Cell>
          <Link to={{ pathname: `/groups/${group.id}`, query: { fromPage: 'groups' } }} style={styles.link}>
            {group.name}
          </Link>
        </Table.Cell>

        <Table.Cell>
          <Link to={{ pathname: `/groups/${group.id}`, query: { fromPage: 'groups' } }} style={styles.link}>
            {group.id}
          </Link>
        </Table.Cell>

        <Table.Cell>{group.permissions.length}</Table.Cell>

        <Table.Cell>{group.users.length}</Table.Cell>
      </Table.Row>
    )
  })

  return (
    <Table columns={5} size="small" fixed selectable sortable>
      <GroupsTableHeader handleSort={handleSort} sortBy={sortBy} sortOrder={sortOrder} />

      <Table.Body>{mappedGroups}</Table.Body>
    </Table>
  )
}

GroupsTable.propTypes = {
  groups: PropTypes.array.isRequired,
  handleSort: PropTypes.func.isRequired,
  sortBy: PropTypes.string.isRequired,
  sortOrder: PropTypes.string.isRequired,
}

export default GroupsTable
